import React from 'react';
import { useSelector } from 'react-redux';
import CustomReactTable from 'Common/Components/Contextualization/CustomReactTable/styled';
import { selectServices, selectIsFetching, selectSelected } from 'store/Contextualization/AssetDetail/selectors';
import getColumns from './components/Columns';
import selectAssetServicesFields from 'store/Preferences/assetServices/selectors';
import useTheme from 'Hooks/UseTheme';

const ServicesTable = () => {
  const { themeStyles } = useTheme();
  const services = useSelector(selectServices);
  const isFetching = useSelector((state) => selectIsFetching('services', state));
  const fields = useSelector(selectAssetServicesFields);
  const columns = getColumns(fields, isFetching);
  const servicesSelected = useSelector((state) => selectSelected('services', state));
  const mockData = [...Array(15).keys()];

  const getTrProps = (rowInfo, servicesSelected) => {
    const selected = servicesSelected.find((vuln) => vuln._id === rowInfo.original._id);
    if (rowInfo && rowInfo.row) {
      return {
        style: {
          background: selected ? `${themeStyles.backgrounds.selectedTableItem}` : 'transparent'
        }
      };
    }
    return {};
  };

  const getThProps = (column, fields) => {
    const defaultMin = fields[column.id] ? fields[column.id].defaultWidth : 0;
    const maxWidth = fields[column.id] ? fields[column.id].maxWidth : 0;
    const response = { minWidth: defaultMin, maxWidth };
    return {
      style: defaultMin ? response : {}
    };
  };

  return (
    <CustomReactTable
      data={ isFetching ? mockData : services }
      columns={ columns }
      minRows={ 0 }
      manual
      showPagination={ false }
      getTrProps={ (_, rowInfo) => getTrProps(rowInfo, servicesSelected) }
      getTheadThProps={ (_, __, column) => getThProps(column, fields) }
      noDataText="Currently, there are no records to display"
    />
  );
};
export default ServicesTable;
